function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { logicalCSS } from '../../../global_styling';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "122lw0e-grow",
  styles: "flex-grow:1;label:grow;"
} : {
  name: "122lw0e-grow",
  styles: "flex-grow:1;label:grow;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1gl6paa-euiHeaderSection",
  styles: "display:flex;flex-grow:0;flex-shrink:0;label:euiHeaderSection;"
} : {
  name: "1gl6paa-euiHeaderSection",
  styles: "display:flex;flex-grow:0;flex-shrink:0;label:euiHeaderSection;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var euiHeaderSectionStyles = function euiHeaderSectionStyles() {
  return {
    euiHeaderSection: _ref2,
    grow: _ref,
    // By default, EuiHeader uses `justify-content: space-between`, which means
    // sections are left-aligned by default (even when alone) with no extra CSS needed
    left: /*#__PURE__*/css(";label:left;"),
    // @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_box_alignment/Box_alignment_in_flexbox#alignment_and_auto_margins
    right: /*#__PURE__*/css(logicalCSS('margin-left', 'auto'), ";;label:right;")
  };
};